<template>
  <SloLoader :loading="loading">
    <slot v-if="isOrderable" :product="product" />
    <slot v-else name="not-orderable" />
  </SloLoader>
</template>

<script>
import {mapGetters} from 'vuex';
import {isProductOrderable, tagManagerTrack} from '../../js/main/utils';
import {marketplaceApi} from '../../js/marketplace/apis/marketplace';
import t from '../../js/main/i18n';
import SloLoader from './SloLoader.vue';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloProductGate',
  filters: {
    t
  },
  components: {
    SloLoader,
    SloIcon
  },
  data() {
    return {
      loading: true,
      isOrderable: false,
      product: null
    };
  },
  props: {
    sku: {type: String, required: true},
    trackView: {type: Boolean, default: false}
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('marketplace', ['cartId'])
  },
  async created() {
    const results = await marketplaceApi.productSearch(this.sku);
    if (results?.data?.products.length) {
      this.product = results.data.products[0];
      this.isOrderable = isProductOrderable(this.product);

      if (this.trackView) {
        tagManagerTrack('view_item', {
          currency: this.product?.price?.currencyIso,
          value: this.product?.price?.value,
          user: this.user?.accountNumber || 'guest',
          cartId: this.cartId,
          items: [
            {
              item_id: this.product?.code,
              item_name: this.product?.name
            }
          ]
        });
      }
    }
    this.loading = false;
  }
};
</script>
